import type {AppLocale} from 'i18n/locales'
import {DEFAULT_LOCALE} from 'i18n/locales'
import {cookiesLegalBodyByLocale} from './cookiesLegalBodies'
import {privacyLegalBodyByLocale} from './privacyLegalBodies'
import {termsLegalBodyByLocale} from './termsLegalBodies'
import type {LegalSlug} from './types'

const bySlug: Record<LegalSlug, Record<AppLocale, string>> = {
  terms: termsLegalBodyByLocale,
  privacy: privacyLegalBodyByLocale,
  cookies: cookiesLegalBodyByLocale,
}

const MIN_BODY_LEN = 80

export function getLegalBodyHtml(
  slug: LegalSlug,
  locale: AppLocale,
): string | undefined {
  const map = bySlug[slug]
  const localesToTry = [locale, DEFAULT_LOCALE, 'bg'].filter(
    (loc, i, arr): loc is AppLocale => arr.indexOf(loc) === i,
  )
  for (const loc of localesToTry) {
    const html = map[loc]
    if (html && html.length >= MIN_BODY_LEN) return html
  }
  return undefined
}
